
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(iniciar, 2500);
});

document.addEventListener("scroll", initOnEvent);
document.addEventListener("mousemove", initOnEvent);
document.addEventListener("touchstart", initOnEvent);

function initOnEvent(event) {
  iniciar();
  event.currentTarget.removeEventListener(event.type, initOnEvent); // remove the event listener that got triggered
}
  // iniciar();

async function initGtm(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != "dataLayer" ? "&l=" + l : "";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
}


async function iniciar() {
  if (window.DidInit) {
    return false;
  }
  window.dispatchEvent(new Event("resize"));
  
  window.DidInit = true;
    initCountDown();

  await initGtm(window, document, "script", "dataLayer", "GTM-PHXR9SJD");

  try {
    console.log("--",window.location.href.search("/obrigado"));
    if (window.location.href.search("/obrigado") > -1) {
      console.log("LEAD");
      fbq("track", "Lead");
    } else {
      console.log("VIEW");
      fbq("track", "PageView");
    }
  } catch {
    console.log("Erro ao iniciar o pixel");
  }
}


function initTiktok(w, d, t) {
  w.TiktokAnalyticsObject = t;
  var ttq = (w[t] = w[t] || []);
  (ttq.methods = [
    "page",
    "track",
    "identify",
    "instances",
    "debug",
    "on",
    "off",
    "once",
    "ready",
    "alias",
    "group",
    "enableCookie",
    "disableCookie",
    "holdConsent",
    "revokeConsent",
    "grantConsent",
  ]),
    (ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    });
  for (var i = 0; i < ttq.methods.length; i++)
    ttq.setAndDefer(ttq, ttq.methods[i]);
  (ttq.instance = function (t) {
    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
      ttq.setAndDefer(e, ttq.methods[n]);
    return e;
  }),
    (ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js",
        o = n && n.partner;
      (ttq._i = ttq._i || {}),
        (ttq._i[e] = []),
        (ttq._i[e]._u = r),
        (ttq._t = ttq._t || {}),
        (ttq._t[e] = +new Date()),
        (ttq._o = ttq._o || {}),
        (ttq._o[e] = n || {});
      n = document.createElement("script");
      (n.type = "text/javascript"),
        (n.async = !0),
        (n.src = r + "?sdkid=" + e + "&lib=" + t);
      e = document.getElementsByTagName("script")[0];
      e.parentNode.insertBefore(n, e);
    });

  ttq.load("CT0DSFBC77U74JDQOD20");
  ttq.page();
}

// add this before event code to all pages where PII data postback is expected and appropriate

function initCountDown() {
  // Set the date we're counting down to
  var countDownDate = new Date("11/07/2026 16:00:00").getTime();
  const conter = document.getElementById("count")
  console.log('conter', conter)
  // Update the count down every 1 second
  if (conter)
  var x = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      // document.getElementById("demo").innerHTML = "EXPIRED";
    } else {
      // Display the result in the element with id="demo"
      document.getElementById("count").innerHTML = `
          <div class="count-item">
            <span class="numero-count">${days}</span>
            <span class="numero-count-label">Dias</span>
          </div>
          <div class="count-item">
            <span class="numero-count">${hours}</span>
            <span class="numero-count-label">Horas</span>
          </div>
          <div class="count-item">
            <span class="numero-count">${minutes}</span>
            <span class="numero-count-label">Minutos</span>
          </div>
          <div class="count-item">
            <span class="numero-count">${seconds}</span>
            <span class="numero-count-label">Segundos</span>
          </div>
        `;
    }
  }, 1000);
}


let flowLoaded = false;

function loadFlow() {
  if (flowLoaded) return;
  flowLoaded = true;
  const s = document.createElement('script');
  s.src = 'https://flow.vetrio.app/api/public/launches/embed/captacao-de-lead-amae-2026';
  s.async = true;
  document.body.appendChild(s);
}

/**
 * <div id="flow-form-captacao-de-lead-amae-2026"></div>
<script src="https://flow.vetrio.app/api/public/launches/embed/captacao-de-lead-amae-2026"></script>
*/
window.clickBtnGrupo = function () {
  // loadFlow();
  // const modal = document.getElementById("modal-one");
  // modal.classList.add("open");
  // const body = document.getElementById("body");
  // body.classList.add("open");
  
  window.location.assign("https://baladapp.com.br/pt-BR/evento/amae-festival/8921");
};

window.falarAtendente = function () {
  window.location.assign("https://wa.me/5543991274999?text=Ol%C3%A1%2C%20quero%20tirar%20uma%20d%C3%BAvida%20sobre%20o%20Ama%C3%AA");
  // window.location.assign("https://wa.me/...");
};

window.fecharModal = function () {
  const modal = document.getElementById("modal-one");
  modal.classList.remove("open");
  const body = document.getElementById("body");
  body.classList.remove("open");
};

window.fecharMenu = function () {
  const menu = document.getElementById("navi-toggle");
  menu.checked = false;
};

window.verMapa = function (stage) {
  const mapa = document.getElementById("mapa");
  mapa.scrollIntoView({ behavior: "smooth" });
};
